import React from 'react'
import type { Selection, SameRaceMultiSelection, BettingType, Race } from '@mobi/betslip/types'
import { isSameRaceMultiSelection } from '@mobi/betslip/helpers/typeGuards'
import { Grid, GridRow, GridCell } from '@mobi/component-library/Common/Grid'
import { Icon } from '@mobi/component-library/Common/Icon'
import { RaceCountdown } from '@core/Components/RaceCountdown'
import {
  MarketPillStyled,
  MarketNameStyled,
  MarketTypeStyled,
} from '@core/Areas/Quickbet/Components/BetInfoHeader/Components/Common/Header.styles'
import { getIconTypeFromMeetingCode } from '@core/Areas/Quickbet/helpers/IconTypeHelper'
import { TitleStyled, CountdownPillStyled } from '@core/Areas/Quickbet/Components/Common.styles'
import { getFixedOrToteDisplay, getMarketTitle } from '@core/Areas/Quickbet/helpers/selections'

export const RaceInfo: React.FC<{
  race: Race
  selection: Selection
  bettingType: BettingType
  isRaceClosed?: boolean
}> = ({ race, selection, bettingType, isRaceClosed = false }) => {
  const { raceNumber, meetingName, raceTime } = race

  const isSameRaceMulti =
    selection != null && isSameRaceMultiSelection(selection as SameRaceMultiSelection)
  const fixedOrToteDisplay = isSameRaceMulti ? '' : getFixedOrToteDisplay(selection, bettingType)
  const marketName = isSameRaceMulti ? 'Same Race Multi' : getMarketTitle(selection)

  const iconType = getIconTypeFromMeetingCode(race.meetingCode)
  return (
    <Grid>
      <GridRow padding='0 0 0.5rem 0'>
        {iconType && (
          <GridCell width='3.5rem'>
            <Icon size='3rem' type={iconType} />
          </GridCell>
        )}
        <GridCell valign='middle'>
          <TitleStyled>
            {meetingName}: R{raceNumber}
          </TitleStyled>
        </GridCell>
      </GridRow>

      <GridRow>
        <GridCell valign='middle'>
          <MarketPillStyled>
            {marketName && <MarketNameStyled>{marketName}</MarketNameStyled>}
            {fixedOrToteDisplay.length > 0 && (
              <MarketTypeStyled>{fixedOrToteDisplay}</MarketTypeStyled>
            )}
          </MarketPillStyled>
        </GridCell>
        <GridCell minWidth='fit-content' flexGrow={0} valign='middle' align='right'>
          <CountdownPillStyled>
            {isRaceClosed ? (
              <span>Closed</span>
            ) : (
              <RaceCountdown displaySize='1.2rem' raceStartTime={new Date(raceTime)} />
            )}
          </CountdownPillStyled>
        </GridCell>
      </GridRow>
    </Grid>
  )
}
